import { Step } from "react-joyride";

export const getPaymentsTourSteps = (): Step[] => [
  {
    target: 'h1',
    content: 'Aquí puedes ver el historial de tus pagos y el estado de tu membresía.',
    placement: 'bottom',
  },
  {
    target: '.payment-status',
    content: 'Este es el estado actual de tu membresía y la fecha de vencimiento.',
    placement: 'bottom',
  },
  {
    target: '.payment-history',
    content: 'Aquí encontrarás un registro detallado de todos tus pagos anteriores.',
    placement: 'top',
  }
];